import React, { Component } from 'react';
import { connect } from 'react-redux';
import PhotoContainer from '../PhotoContainer';

class Team extends Component {
  render() {
    const { team, selectedTeam, showArchivedTeams } = this.props;

    let selected = false;
    if (selectedTeam && selectedTeam.id === team.id) {
      selected = true;
    }

    return (
      <div className="team">
        <div className="top">
          <div className="team-photo">
            <PhotoContainer
              className="photo-container"
              image={team.avatar}
              defaultImg="team"
            />
          </div>
          <div className="team-title">{team.name}</div>
        </div>

        {showArchivedTeams ? (
          <div className="team-footer-buttons">
            <div
              className="button-text button-recover"
              onClick={() => this.props.handleClick(team)}
            >
              {this.props.button}
            </div>
            <div
              className="button-text button-delete"
              onClick={() => this.props.handleClick(team, true)}
            >
              DELETE
            </div>
          </div>
        ) : (
          <div className="team-footer-buttons">
            <div
              className={`button-text ${selected && 'selected'}`}
              onClick={() => this.props.handleClick(team)}
            >
              {this.props.button}
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  selectedTeam: state.teams.selectedTeam,
});

export default connect(mapStateToProps)(Team);



// WEBPACK FOOTER //
// src/components/Teams/Team.jsx